// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/styles/utilities/loader.css */

/* Fixed Full-Screen Overlay */
#loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  /* eslint-disable-next-line css/use-baseline */
  backdrop-filter: blur(8px); /* Matches your glassmorphism theme */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  transition: opacity 0.5s ease-out;
}

/* The Pulsing Celestial Body */
.pulse-loader {
  width: 80px;
  height: 80px;
  background: radial-gradient(
    circle,
    #ffd700 0%,
    #ff8c00 70%,
    transparent 100%
  );
  border-radius: 50%;
  box-shadow: 0 0 30px rgba(255, 215, 0, 0.6);
  animation: celestial-pulse 1.5s infinite ease-in-out;
}

@keyframes celestial-pulse {
  0% {
    transform: scale(0.9);
    opacity: 0.7;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
    box-shadow: 0 0 50px rgba(255, 215, 0, 0.8);
  }
  100% {
    transform: scale(0.9);
    opacity: 0.7;
  }
}

.hidden {
  opacity: 0;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/styles/utilities/loader.css"],"names":[],"mappings":"AAAA,oCAAoC;;AAEpC,8BAA8B;AAC9B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,8CAA8C;EAC9C,0BAA0B,EAAE,qCAAqC;EACjE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,iCAAiC;AACnC;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,kBAAkB;EAClB,2CAA2C;EAC3C,oDAAoD;AACtD;;AAEA;EACE;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;IACV,2CAA2C;EAC7C;EACA;IACE,qBAAqB;IACrB,YAAY;EACd;AACF;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB","sourcesContent":["/* src/styles/utilities/loader.css */\n\n/* Fixed Full-Screen Overlay */\n#loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.6);\n  /* eslint-disable-next-line css/use-baseline */\n  backdrop-filter: blur(8px); /* Matches your glassmorphism theme */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n  transition: opacity 0.5s ease-out;\n}\n\n/* The Pulsing Celestial Body */\n.pulse-loader {\n  width: 80px;\n  height: 80px;\n  background: radial-gradient(\n    circle,\n    #ffd700 0%,\n    #ff8c00 70%,\n    transparent 100%\n  );\n  border-radius: 50%;\n  box-shadow: 0 0 30px rgba(255, 215, 0, 0.6);\n  animation: celestial-pulse 1.5s infinite ease-in-out;\n}\n\n@keyframes celestial-pulse {\n  0% {\n    transform: scale(0.9);\n    opacity: 0.7;\n  }\n  50% {\n    transform: scale(1.1);\n    opacity: 1;\n    box-shadow: 0 0 50px rgba(255, 215, 0, 0.8);\n  }\n  100% {\n    transform: scale(0.9);\n    opacity: 0.7;\n  }\n}\n\n.hidden {\n  opacity: 0;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
